import React, { useState } from 'react';
import styled from 'styled-components';
import { addPerson } from '../../../firebaseServices/firebaseServices'; // Importez votre fonction ici
import { Text } from '../../atoms/Text';

// STYLES
import {
  colors,
  fontFamily,
  fontSize,
} from '../../../Design_System/DesignSystem';

const FormWrapper = styled.div`
  max-width: 400px; // Limite la largeur du formulaire
  margin: auto; // Centre le formulaire
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 600px) {
    width: 90%; // Ajuste la largeur pour les écrans plus petits
  }
`;

const Input = styled.input`
  width: 92%;
  padding: 10px;
  margin-bottom: 15px;
  margin-top: 15px;
  border: 1px solid ${colors.tan}; // Bordure rouge
  border-radius: 4px;
  color: ${colors.tan}; // Texte en rouge
  background-color: transparent; // Fond transparent

  @media (max-width: 600px) {
    padding: 8px; // Ajuste le padding pour les écrans plus petits
  }

  &:focus {
    outline: none; // Retire le contour par défaut du focus
    border-color: ${colors.tan}; // Changer la couleur de la bordure au focus
  }

  &::placeholder {
    color: ${colors.tan}; // Couleur du placeholder en rouge
    opacity: 0.7; // Assurez-vous que le placeholder est entièrement opaque
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #28a745; // Couleur du bouton
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #218838; // Couleur au survol
  }

  @media (max-width: 600px) {
    padding: 8px; // Ajuste le padding pour les écrans plus petits
  }
`;

const Title = styled.div`
  cursor: pointer;
`;

const TitleContainer = styled.div`
  display: flex;
  overflow: hidden; /* Pour éviter le débordement */
  justify-content: space-between;
  align-items: flex-end;
`;

interface AddPersonFormProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
}

const AddPersonForm = ({ setSelectedItem }: AddPersonFormProps) => {
  const [name, setName] = useState('');
  const [onContact, setOnContact] = useState<boolean>(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); // Réinitialise l'erreur

    if (!name) {
      setError('Le nom est requis.'); // Validation simple
      return;
    }

    try {
      await addPerson(name, onContact); // Passer onContact ici
      setName(''); // Réinitialise le champ du nom après soumission
      setOnContact(false); // Réinitialiser onContact après soumission
      setSelectedItem(7);
    } catch (error) {
      setError("Erreur lors de l'ajout de la personne."); // Gérer les erreurs de soumission
    }
  };

  return (
    <FormWrapper>
      <TitleContainer>
        {' '}
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.tinos}
          bold={false}
          justify={false}
        >
          Ajouter une personne
        </Text>
        <Title onClick={() => setSelectedItem(7)}>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.tinos}
            bold={true}
            justify={false}
          >
            Retour
          </Text>
        </Title>
      </TitleContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <form onSubmit={handleSubmit}>
        <Input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nom de la personne"
        />

        {/* Nouveau champ pour onContact */}
        <div>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.tinos}
            bold={false}
            justify={false}
          >
            Encore en contact ?
          </Text>
          <label>
            <input
              type="radio"
              value="oui"
              checked={onContact === true}
              onChange={() => setOnContact(true)}
            />
            <Text
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              oui
            </Text>
          </label>
          <label>
            <input
              type="radio"
              value="non"
              checked={onContact === false}
              onChange={() => setOnContact(false)}
            />
            <Text
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              non
            </Text>
          </label>
        </div>

        <Button type="submit">Ajouter</Button>
      </form>
    </FormWrapper>
  );
};

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 15px;
`;

export default AddPersonForm;
